// API Configuration
// REACT_APP_API_BASE_URL should be set in .env.development (dev) or .env.production (prod)
// REACT_APP_TEMPLATE_BASE_URL should be set in .env.development (dev) or .env.production (prod)
// 
// Development: Set these in client/.env.development
// Production: Set these in client/.env.production (or build-time env vars)

const getApiBaseUrl = () => {
  // If explicitly set via environment variable, use it
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // In production, use relative path (works with reverse proxy)
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }
  
  // In development, warn if not set and use fallback
  if (process.env.NODE_ENV === 'development') {
    console.warn('[WARNING] REACT_APP_API_BASE_URL not set in .env.development. Using fallback localhost:3005');
    const devPort = process.env.REACT_APP_DEV_SERVER_PORT || '3005';
    return `http://localhost:${devPort}/api`;
  }
  
  // Default fallback (should not reach here in normal operation)
  return '/api';
};

const getTemplateBaseUrl = () => {
  // If explicitly set via environment variable, use it
  if (process.env.REACT_APP_TEMPLATE_BASE_URL) {
    return process.env.REACT_APP_TEMPLATE_BASE_URL;
  }
  
  // In production, use relative path
  if (process.env.NODE_ENV === 'production') {
    return '/api/templates';
  }
  
  // In development, warn if not set and use fallback
  if (process.env.NODE_ENV === 'development') {
    console.warn('[WARNING] REACT_APP_TEMPLATE_BASE_URL not set in .env.development. Using fallback localhost:3005');
    const devPort = process.env.REACT_APP_DEV_SERVER_PORT || '3005';
    return `http://localhost:${devPort}/api/templates`;
  }
  
  // Default fallback (should not reach here in normal operation)
  return '/api/templates';
};

export const API_BASE_URL = getApiBaseUrl();
export const TEMPLATE_BASE_URL = getTemplateBaseUrl();

// Debug logging in development
if (process.env.NODE_ENV === 'development') {
  console.log('[API Config] API_BASE_URL:', API_BASE_URL);
  console.log('[API Config] TEMPLATE_BASE_URL:', TEMPLATE_BASE_URL);
  console.log('[API Config] REACT_APP_API_BASE_URL env var:', process.env.REACT_APP_API_BASE_URL);
}
